





















































import Vue from 'vue'
import { AdminListItemData } from '../types'

export default Vue.extend({
  name: 'AdminList',
  props: {
    headers: {
      required: true,
      type: Array as () => Array<any>
    },
    items: {
      required: true,
      type: Array as () => Array<AdminListItemData>
    },
    totalItems: {
      required: true,
      type: Number
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  }
})
